import React from 'react';
import PriceItemList from '../PriceItemList/PriceItemList';

const OrderSuccess = (props) => {
  let subTitle = null;
  let remark = 'פרטי כניסה נשלחו אליך בהודעת SMS';

  switch (props.summaryDetails.saleType) {
    case 'tv':
      subTitle = <>תוכלו להוריד כבר עכשיו את האפליקציה שלנו וליהנות מכל התכנים ללא צורך בטכנאי</>;
      break;
    case 'app':
      subTitle = <>תוכלו להוריד כבר עכשיו את האפליקציה שלנו וליהנות מכל התכנים של {window.Config.brand_Name_HE}</>;
      break;
    case 'internet':
      subTitle = <>אוטוטו תתחילו להנות מאינטרנט מהיר, איכותי ויציב</>;
      break;
    case 'triple':
      subTitle = <>תוכלו להוריד כבר עכשיו את האפליקציה שלנו וליהנות מכל התכנים ללא צורך בטכנאי</>;
      break;
  }

  function displayPrice(price) {
    if (typeof price === 'number') {
      return parseFloat(price.toFixed(2));
    } else {
      return parseFloat(parseFloat(price).toFixed(2));
    }
  }

  return (
    <div id='details' className='order-success-wrapper'>
      <div>
        <div className='sub-title-text'>{subTitle}</div>

        {!props.isKosherSubscriber && <div className='remark-text'>{remark}</div>}

        <div className='position-of-img'>
          <div className='google-play'></div>
          <div className='app-store'></div>
        </div>
      </div>

      <PriceItemList summaryDetails={props.summaryDetails}/>

      {(props.summaryDetails.supplyType == 'technician' || props.summaryDetails.supplyType == 'delivery') && (
        <>
          <div className='show-address-location'>
            <div className='title-order-detail'>פרטי הזמנה</div>
            <div className='sub-order-detail'>
              {props.summaryDetails.supplyType == 'technician' && (
                <div className='row-details'> מועד הגעת הטכנאי: {props.summaryDetails.selectedTechnicianTimeDisplay} </div>
              )}
              {props.summaryDetails.supplyType == 'delivery' && (
                <div className='row-details'> מתי השליח יגיע: {props.summaryDetails.selectedDeliveryTimeDisplay} </div>
              )}
              {props.summaryDetails.saleType != 'app' && (
                <div className='row-details'>
                  כתובת: {props.summaryDetails.selectedAddress?.streetName} {props.summaryDetails.selectedAddress?.home} ,
                  {props.summaryDetails.selectedAddress?.cityName}
                </div>
              )}
              {props.summaryDetails.saleType != 'app' && (
                <div className='row-details'>
                  טלפון ליצירת קשר: {props.summaryDetails.personalInfo?.firstName} {props.summaryDetails.personalInfo?.subscriberNo}
                </div>
              )}
            </div>
          </div>
        </>
      )}

      <div className='order-confirmation'>
        {props.isKosherSubscriber ? <> אישור ההזמנה נשלח למייל שמסרת ברגעים אלו. </> : <> אישור ההזמנה נשלח לטלפון שמסרת ברגעים אלו. </>}
        <br />
        מספר הזמנה {props.summaryDetails.orderNumber}
      </div>
    </div>
  );

};

export default OrderSuccess;
